import { render, staticRenderFns } from "./AppointmentInfo.vue?vue&type=template&id=948903fe&scoped=true&"
import script from "./AppointmentInfo.vue?vue&type=script&lang=js&"
export * from "./AppointmentInfo.vue?vue&type=script&lang=js&"
import style0 from "./AppointmentInfo.vue?vue&type=style&index=0&id=948903fe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "948903fe",
  null
  
)

export default component.exports